import React, { Component } from 'react';

interface ImgLazyLoadProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
}

interface ImgLazyLoadState {
  isVisible: boolean;
}

class ImgLazyLoad extends Component<ImgLazyLoadProps, ImgLazyLoadState> {
  private imgElement: HTMLImageElement | null = null;
  private observer: IntersectionObserver | null = null;

  constructor(props: ImgLazyLoadProps) {
    super(props);
    this.state = {
      isVisible: false,
    };
  }

  setRef = (element: HTMLImageElement | null) => {
    this.imgElement = element;
  };

  componentDidMount() {
    if (this.imgElement && !this.state.isVisible) {
      this.observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            this.setState({ isVisible: true });
            if (this.observer) {
              this.observer.disconnect();
            }
          }
        },
        {
          rootMargin: '10px',
        }
      );
      this.observer.observe(this.imgElement);
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  render() {
    const { src, alt, ...props } = this.props;
    const { isVisible } = this.state;

    return (
      <img
        ref={this.setRef}
        src={isVisible ? src : ''}
        alt={alt}
        {...props}
      />
    );
  }
}

export default ImgLazyLoad;
